import React from "react";
import {
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
  Article,
  Visibility,
} from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { formatText, trimmedDate } from "utils/helper";

export const getArrowIcon = (value, size = "medium") => {
  if (parseFloat(value) === 0)
    return <ArrowForward color="action" fontSize={size} />;
  if (parseFloat(value) > 0)
    return <ArrowUpward color="success" fontSize={size} />;
  return <ArrowDownward color="error" fontSize={size} />;
};

export const columns = (handleViewClick, onViewDocument) => {
  return [
    {
      field: "view_cpt",
      headerName: "CPT/ICD",
      width: 120,
      renderCell: (params) => (
        <IconButton
          color="primary"
          size="small"
          onClick={() => {
            handleViewClick(params.row);
          }}
        >
          <Visibility />
        </IconButton>
      ),
    },
    {
      field: "document",
      headerName: "",
      width: 60,
      renderCell: (params) => (
        <IconButton
          color="primary"
          size="small"
          onClick={() => {
            onViewDocument(params.row, "CPT");
          }}
        >
          <Article />
        </IconButton>
      ),
    },
    {
      field: "claim_no",
      headerName: "Encounter No",
      width: 110,
      cellClassName: "demo-bg",
    },
    {
      field: "service_date",
      headerName: "Service Date",
      width: 170,
      cellClassName: "demo-bg",
      renderCell: (e) => <div>{trimmedDate(e.value)}</div>,
    },
    {
      field: "visit_type",
      headerName: "Visit Type",
      width: 180,
      cellClassName: "demo-bg",
    },
    {
      field: "is_televisit",
      headerName: "Televisit",
      width: 120,
      cellClassName: "demo-bg",
    },
    {
      field: "rendering_provider",
      headerName: "Provider",
      width: 170,
      cellClassName: "demo-bg",
    },
    {
      field: "patient_acct_no",
      headerName: "Patient Acct",
      width: 120,
      cellClassName: "demo-bg",
    },
    {
      field: "patient_name",
      headerName: "Patient Name",
      width: 170,
      cellClassName: "demo-bg",
    },
    {
      field: "patient_gender",
      headerName: "Gender",
      width: 100,
      cellClassName: "demo-bg",
    },
    {
      field: "patient_age",
      headerName: "Age",
      width: 80,
      cellClassName: "demo-bg",
    },
    {
      field: "ai_recommended_raf_score",
      headerName: "AI RAF",
      width: 110,
      cellClassName: "icd-bg",
    },

    {
      field: "icd_user_review_status",
      headerName: "ICD Review",
      width: 140,
      cellClassName: "icd-bg",
      renderCell: (e) => <div>{formatText(e.value)}</div>,
    },
    // CPT columns
    {
      field: "ai_recommended_rvu_total",
      headerName: "AI RVU",
      width: 110,
      cellClassName: "cpt-bg",
    },
    {
      field: "cpt_user_review_status",
      headerName: "CPT Review",
      width: 140,
      cellClassName: "cpt-bg",
      renderCell: (e) => <div>{formatText(e.value)}</div>,
    },
  ];
};
